<template>
  <div class="lots-tab">
    <v-progress-linear class="loading" v-show="loading" :indeterminate="true"></v-progress-linear>
    <search-input :search="this.search" placeholder="Search" @on-search="handleSearch" @on-clear="handleClearSearch"></search-input>
    <div v-show="!loading" class="total-ctn">{{lotCount}} {{ lotCount ? 'lots' : 'lot' }} found.</div>
    <list v-show="!loading">
      <list-item v-for="lot in lotList" @handle-click="handleClick(lot)" :key="lot.id" :selected="selectedLot.id == lot.id" slot="item">
        <lot-item :lot="lot">
        </lot-item>
      </list-item>
      <info-card v-if="this.selectedLot && this.selectedLot.id" slot="info-card">
        <lot-card :lot="this.selectedLot"></lot-card>
      </info-card>
    </list>
  </div>
</template>

<script>

import List from '@/components/List'
import ListItem from '@/components/ListItem'
import InfoCard from '@/components/InfoCard'

import LotItem from '@/components/LotItem'
import LotCard from '@/components/LotCard'

import SearchInput from '@/components/SearchInput'

import { mapGetters } from 'vuex'

export default {
  name: 'LotsTab',
  components: {
    'list': List,
    'list-item': ListItem,
    'lot-item': LotItem,
    'info-card': InfoCard,
    'lot-card': LotCard,
    'search-input': SearchInput
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedLot: 'selectedLot',
      lotList: 'filteredLotList',
      profile: 'profile',
      loading: 'lotLoading',
      lotCount: 'lotCount'
    })
  },
  watch: {
    $route (to, from) {
      if (to.path === '/lots' && to.query.search) {
        this.handleSearch(to.query.search)
      }
    }
  },
  methods: {
    handleClick (lot) {
      this.$store.dispatch('selectLot', { lot: lot })
    },

    handleClearSearch () {
      this.$router.push('lots')
    },

    handleSearch (search) {
      this.search = search
      this.$store.dispatch('clearLotSelection')
      let owner = this.profile.organization.role === 'brand' ? '' : this.profile.organization.id
      this.$store.dispatch('searchLot', { search, owner }).then(() => {
        this.$store.dispatch('selectLot', { lot: this.lotList[0] })
      })
    }
  },
  created () {
    if (this.$route.query.search) {
      this.handleSearch(this.$route.query.search)
    }
    if (this.profile.organization.role === 'brand') {
      this.$store.dispatch('loadShipmentList', { })
      this.$store.dispatch('loadProcessors', { })
      this.$store.dispatch('loadLotList', { })
    } else {
      this.$store.dispatch('loadShipmentList', { owner: this.profile.organization.id })
      this.$store.dispatch('loadProcessor', { owner: this.profile.organization.id })
      this.$store.dispatch('loadLotList', { owner: this.profile.organization.id })
    }
  }
}

</script>

<style lang="scss" scoped>

.farms-tab{
  padding: 0px;
  background: white;
}

.loading{
  position: absolute;
  margin-top: 0px;
  top: 0px;
}

.total-ctn{
  padding-left: 16px;
  padding-top: 15px;
  font-size: 15px;
  font-weight: bold;
}

</style>
